<section>
  <div class="vertical-container-simple column-gap-0p5">
    <app-tabs-with-counter
      data-qa="kpi-metrics-main-tabs"
      [initialTabIndex]="tabs.selectedIndex"
      [tabNamesRaw]="tabs.all"
      (selectedTabEmitter)="switchTab($event)"
      [type]="TabType.Grey"
    />
    <router-outlet/>
  </div>
</section>
